import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  isBrowser,
  lazyLoadingRefresh,
  splitListIntoChunks,
} from '../../../helpers';
import SpeakerBlock from './SpeakerBlock/SpeakerBlock';
import './SpeakersTable.scss';

export default class SpeakersTable extends PureComponent {
  static propTypes = {
    speakers: PropTypes.array.isRequired,
    siteType: PropTypes.oneOf(['EVENT', 'COURSE']),
  };

  componentDidMount() {
    this.updateBlocksHeight();

    window.addEventListener('resize', () => this.updateBlocksHeight());
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this.updateBlocksHeight());
  }

  componentDidUpdate() {
    this.updateBlocksHeight();

    if (isBrowser()) {
      lazyLoadingRefresh();
    }
  }

  updateBlocksHeight() {
    const speakersContentContainer = document.getElementById(
      'speakersContentContainer',
    );

    const textNodes = speakersContentContainer.querySelectorAll(
      '.c-speaker-block__job, .c-speaker-block__company',
    );
    for (let i = 0; i < textNodes.length; i++) {
      textNodes[i].style.height = 'auto';
    }

    const speakersNodes = speakersContentContainer.childNodes;

    const speakersNodesChunks = splitListIntoChunks(speakersNodes, 2);

    const setHeight = (chunk, className) => {
      const aNode = chunk[0] ? chunk[0].querySelector(className) || null : null;
      const bNode = chunk[1] ? chunk[1].querySelector(className) || null : null;
      const aHeight = aNode ? aNode.clientHeight : 0;
      const bHeight = bNode ? bNode.clientHeight : 0;
      const height = Math.max(aHeight, bHeight);
      aHeight && (aNode.style.height = height + 'px');
      bHeight && (bNode.style.height = height + 'px');
    };

    speakersNodesChunks.forEach((chunk) => {
      setHeight(chunk, '.c-speaker-block__name');
      setHeight(chunk, '.c-speaker-block__job');
      setHeight(chunk, '.c-speaker-block__company');
    });
  }

  render() {
    const { speakers = [], siteType } = this.props;

    return (
      <div className="c-speakers-table">
        <div className="row" id="speakersContentContainer">
          {speakers.map((speaker, index) => (
            <div key={index} className="col-xs-12 col-md-6">
              <SpeakerBlock speaker={speaker} siteType={siteType} />
            </div>
          ))}
        </div>
      </div>
    );
  }
}
